
export const PLATFORM_NAME = '亿合道后台综合管理系统'
export const VERSION = '2.0.5'

export const BASE_API_PATH = ''

export const TOKEN_KEY = 'X-Access-Token'
export const TOKEN_KEY_URL = ':X_Access_Token'

export const Version_Code = 'version_code'

export const PREFIX = 'admin_'

export const OSS_BUCKETNAME = 'file-1322379458'
export const OSS_HOST = `${OSS_BUCKETNAME}.cos.ap-chengdu.myqcloud.com`;


